module.exports = __webpack_public_path__ + "static/media/Wakefield-whisteblowing-policy-2021-1.8f9384df.pdf";